export default __webpack_public_path__ + "static/media/triber-gallery-1.d2f39920.jpg";